{
  "comum": {
    "carregando": "Carregando…",
    "vazio": "Nada por aqui",
    "vazioDescricao": "Não há registros para exibir.",
    "erro": "Algo deu errado",
    "erroDescricao": "Não foi possível carregar. Tente de novo em instantes.",
    "semPermissao": "Sem permissão",
    "semPermissaoDescricao": "Seu perfil não permite ver esta informação.",
    "tentarDeNovo": "Tentar de novo",
    "salvar": "Salvar",
    "cancelar": "Cancelar",
    "buscar": "Buscar",
    "obrigatorio": "Obrigatório",
    "excluir": "Excluir"
  },
  "tema": {
    "titulo": "Aparência",
    "claro": "Claro",
    "escuro": "Escuro",
    "sistema": "Seguir o sistema",
    "alternar": "Alternar tema"
  },
  "marca": {
    "titulo": "Marca",
    "digiorgio": "Di Giorgio Impressores",
    "letraseversos": "Letras e Versos",
    "interno": "Interno"
  },
  "catalogo": {
    "titulo": "Catálogo de componentes",
    "descricao": "Cada componente nos cinco estados obrigatórios, nos dois temas.",
    "estados": "Estados",
    "botoes": "Botões",
    "campos": "Campos",
    "avisos": "Avisos",
    "cartoes": "Cartões",
    "tipografia": "Tipografia",
    "exemploNumero": "Número",
    "exemploMoeda": "Moeda",
    "exemploData": "Data",
    "exemploPlural_one": "{{count}} orçamento calculado",
    "exemploPlural_other": "{{count}} orçamentos calculados"
  },
  "acao": {
    "primaria": "Ação primária",
    "secundaria": "Ação secundária",
    "perigosa": "Excluir",
    "desabilitada": "Indisponível"
  },
  "campo": {
    "rotulo": "Nome do cliente",
    "ajuda": "Como aparece na proposta.",
    "erro": "Informe o nome do cliente."
  },
  "app": {
    "titulo": "Portal Rio DG",
    "descricao": "Atendimento multicanal com IA.",
    "fundacao": "Fundação visual",
    "avisoCatalogo": "As telas de negócio chegam nas próximas entregas. Por ora, o catálogo mostra os componentes-base nos dois temas.",
    "abrirCatalogo": "Abrir o catálogo",
    "inicioDescricao": "As últimas 24 horas do atendimento."
  },
  "historico": {
    "aguardando": "Aguardando o contato…",
    "carregando": "Carregando…",
    "procurando": "Procurando pelo nome no acervo…",
    "semTelefone": "Este contato não tem telefone nem identificador",
    "semHistorico": "Sem histórico para este contato no acervo.",
    "buscamosPor": "buscamos por {{tipo}}: {{valor}}",
    "tipoTelefone": "telefone",
    "tipoIdentificador": "id do canal",
    "notaInterna": "nota interna",
    "semTexto": "(sem texto — {{tipo}})",
    "evento": "(evento)",
    "nadaEncontrado": "Nada encontrado no acervo.",
    "placeholderBusca": "nome ou número",
    "resumo": "{{atendimentos}} atendimento(s) · {{mensagens}} mensagens · acervo Zintech",
    "anexos": "{{count}} anexo(s)",
    "contato": "Contato",
    "buscaFalhou": "Não consegui consultar o acervo agora. Isso é diferente de não ter encontrado nada.",
    "buscaAvulsa": "Procure o cliente pelo nome ou pelo telefone para ver o histórico anterior."
  },
  "acesso": {
    "titulo": "Portal Rio DG",
    "descricao": "Entre com seu e-mail e senha.",
    "email": "E-mail",
    "senha": "Senha",
    "entrar": "Entrar",
    "esqueci": "Esqueci minha senha",
    "codigo": "Código de acesso",
    "codigoAjuda": "Seis dígitos, ou um código de emergência.",
    "codigoEnviado": "Enviamos um código para o seu e-mail. Ele vale por 10 minutos.",
    "confirmar": "Confirmar",
    "credencialInvalida": "E-mail, senha ou código incorretos.",
    "muitasTentativas": "Muitas tentativas. Aguarde um minuto e tente de novo.",
    "emailIndisponivel": "Não foi possível enviar o código. Procure o administrador.",
    "erroRede": "Não foi possível falar com o servidor. Verifique sua conexão.",
    "sair": "Sair"
  },
  "recuperar": {
    "titulo": "Recuperar senha",
    "descricao": "Informe seu e-mail. Se houver cadastro, enviaremos um link para você criar uma senha nova.",
    "enviar": "Enviar link",
    "enviado": "Pedido recebido.",
    "enviadoDetalhe": "Se este e-mail estiver cadastrado, o link chega em instantes. Ele vale por 1 hora.",
    "voltar": "Voltar para a entrada"
  },
  "definirSenha": {
    "titulo": "Nova senha",
    "tituloConvite": "Bem-vindo ao Portal Rio DG",
    "descricao": "Escolha uma senha nova. As demais sessões serão encerradas.",
    "descricaoConvite": "Escolha a sua senha para concluir o primeiro acesso.",
    "nova": "Nova senha",
    "repetir": "Repita a senha",
    "minimo": "Pelo menos {{minimo}} caracteres.",
    "curta": "A senha precisa ter pelo menos {{minimo}} caracteres.",
    "diferente": "As senhas não são iguais.",
    "salvar": "Salvar senha",
    "pronto": "Senha definida. Você já pode entrar.",
    "entrarAgora": "Ir para a entrada",
    "semToken": "Link inválido. Peça um novo pela tela de recuperação."
  },
  "perfil": {
    "Leitura": "Leitura",
    "LeituraDescricao": "Consulta histórico e configuração, sem alterar nada.",
    "Operacao": "Operação",
    "OperacaoDescricao": "Consulta e ajusta a configuração de negócio.",
    "Administrador": "Administrador",
    "AdministradorDescricao": "Tudo, inclusive usuários, auditoria e e-mail. Sempre com segundo fator."
  },
  "usuarios": {
    "titulo": "Usuários",
    "descricao": "Quem entra no portal e o que cada um pode fazer.",
    "legenda": "Usuários do portal, com perfil, situação e último acesso.",
    "novo": "Novo usuário",
    "novoTitulo": "Novo usuário",
    "editarTitulo": "Editar usuário",
    "nome": "Nome",
    "perfil": "Perfil",
    "situacao": "Situação",
    "ultimoAcesso": "Último acesso",
    "acoes": "Ações",
    "editar": "Editar",
    "ativo": "Ativo",
    "inativo": "Inativo",
    "ativoRotulo": "Usuário ativo",
    "ativoAjuda": "Desativar encerra as sessões abertas imediatamente.",
    "convitePendente": "Convite pendente",
    "reenviarConvite": "Reenviar convite",
    "conviteReenviado": "Convite reenviado.",
    "conviteFalhou": "Não foi possível enviar o convite. Verifique a configuração de e-mail.",
    "revogar": "Encerrar {{total}} sessão(ões)",
    "sessoesRevogadas": "{{total}} sessão(ões) encerrada(s).",
    "segundoFator": "Exigir segundo fator",
    "segundoFatorAjuda": "Código enviado por e-mail a cada entrada.",
    "segundoFatorForcado": "Obrigatório para administradores — não pode ser desligado.",
    "emailAjuda": "O convite para definir a senha vai para este endereço.",
    "emailImutavel": "O e-mail identifica o usuário na auditoria e não muda.",
    "salvo": "Usuário salvo.",
    "criadoComConvite": "Usuário criado. O convite foi enviado.",
    "criadoSemConvite": "Usuário criado, mas o convite não saiu. Verifique a configuração de e-mail."
  },
  "smtp": {
    "titulo": "Servidor de e-mail",
    "descricao": "Por aqui saem o código de acesso e o link de recuperação de senha. Configuração errada tranca todo mundo do lado de fora.",
    "servidorTitulo": "Conexão",
    "servidor": "Servidor",
    "porta": "Porta",
    "seguranca": "Segurança",
    "segAutomatica": "Automática",
    "segAutomaticaAjuda": "Usa TLS quando o servidor oferece. Serve para a maioria dos casos.",
    "segStartTls": "STARTTLS",
    "segStartTlsAjuda": "Conexão em claro promovida a TLS. Normalmente porta 587.",
    "segTlsImplicito": "TLS na conexão",
    "segTlsImplicitoAjuda": "Cifrado desde o início. Normalmente porta 465.",
    "segNenhuma": "Nenhuma",
    "segNenhumaAjuda": "Sem cifra. Só para servidor interno de teste — expõe a senha na rede.",
    "usuario": "Usuário",
    "senha": "Senha",
    "senhaGravada": "Há uma senha gravada. Deixe em branco para mantê-la.",
    "senhaAusente": "Nenhuma senha gravada.",
    "remetenteEmail": "E-mail do remetente",
    "remetenteAjuda": "Precisa ter SPF e DKIM do domínio, senão as mensagens caem em spam.",
    "remetenteNome": "Nome do remetente",
    "urlBase": "Endereço do portal",
    "urlBaseAjuda": "Base dos links de convite e recuperação. Ex.: https://portal.riodg.com.br",
    "salvo": "Configuração salva.",
    "testeTitulo": "Enviar e-mail de teste",
    "testeDescricao": "Testa o que está no formulário acima, mesmo sem salvar.",
    "testeDestinatario": "Enviar para",
    "testar": "Enviar teste",
    "testeOk": "Mensagem enviada para {{destinatario}}.",
    "testeFalhou": "Falhou: {{erro}}"
  },
  "portal": {
    "usuarios": "Usuários",
    "smtp": "Servidor de e-mail",
    "catalogo": "Catálogo",
    "ola": "Olá, {{nome}}",
    "ia": "Consumo de IA",
    "assistentes": "Assistentes",
    "simulacao": "Simular orçamento",
    "orcamentos": "Orçamentos",
    "conhecimento": "Base de conhecimento",
    "painel": "Painel",
    "roteamento": "Roteamento",
    "tabela": "Tabela de preços",
    "atalhos": "Atalhos",
    "caixas": "Canais",
    "cotacao": "Cotação",
    "contatos": "Contato único",
    "acervo": "Histórico Zintech",
    "avaliacoes": "Avaliações"
  },
  "ia": {
    "titulo": "Consumo de IA",
    "descricao": "Quanto o atendimento automatizado está custando e quanto crédito resta.",
    "periodo": "Período",
    "dias": "{{total}} dias",
    "projecaoTitulo": "Situação atual",
    "diasRestantes": "Dias restantes",
    "noRitmoAtual": "No ritmo atual.",
    "semSaldoInformado": "Informe o saldo da conta para ver a projeção.",
    "saldoTitulo": "Saldo da conta do provedor",
    "saldoAtual": "Saldo estimado hoje",
    "saldoNuncaInformado": "Nunca informado — sem ele não há projeção nem alerta",
    "saldoInformadoEm": "Informado {{valor}} em {{data}}",
    "consumidoDesde": "Consumido desde então",
    "consumidoDesdeAjuda": "Descontado do saldo informado, pelo custo real de cada chamada",
    "saldoRotulo": "Novo saldo (R$)",
    "saldoAjuda": "O valor que está na conta do provedor agora. Atualize a cada recarga — o consumo é descontado sozinho a partir daqui.",
    "saldoGravar": "Informar saldo",
    "saldoInvalido": "Informe um valor em reais, por exemplo 150,00",
    "saldoFalhou": "Não foi possível gravar o saldo. Tente de novo.",
    "mediaDiaria": "Consumo por dia",
    "mediaDe": "Média de {{total}} dias.",
    "totalDoPeriodo": "Total do período",
    "chamadas": "{{total}} chamada(s).",
    "quedas": "Quedas para a reserva",
    "quedasAjuda": "Acima de zero indica provedor principal instável.",
    "alertaTitulo": "Crédito de IA acabando",
    "alertaCorpo": "Restam cerca de {{dias}} dia(s) no ritmo atual. Recarregue a conta do provedor antes que o atendimento pare.",
    "porAssistente": "Por assistente",
    "legenda": "Consumo de cada assistente no período: chamadas, tokens e custo.",
    "assistente": "Assistente",
    "chamadasColuna": "Chamadas",
    "tokens": "Tokens",
    "custo": "Custo",
    "porConversa": "Por conversa",
    "semConsumo": "Nenhuma chamada ao modelo no período."
  },
  "assistentes": {
    "titulo": "Assistentes",
    "descricao": "Comportamento dos assistentes da marca {{marca}}.",
    "legenda": "Assistentes da marca, com canal, modelo e situação.",
    "vazio": "Nenhum assistente cadastrado nesta marca.",
    "nome": "Nome",
    "nomeAjuda": "É assim que o assistente se apresenta ao cliente.",
    "canal": "Canal",
    "semCanal": "Sem canal",
    "modelo": "Modelo",
    "interno": "Interno",
    "ver": "Ver",
    "voltar": "Voltar à lista",
    "formularioDescricao": "O que você ajusta aqui muda o texto que o modelo recebe, à direita.",
    "somenteLeitura": "Seu perfil permite ver, mas não alterar.",
    "comportamento": "Comportamento",
    "persona": "Identidade",
    "personaAjuda": "Uma ou duas frases sobre quem é o assistente. Redação, não regra.",
    "brevidade": "Tamanho da resposta",
    "brevidadeCurta": "Curta",
    "brevidadeCurtaAjuda": "Uma ou duas frases. Recomendado para mensageria.",
    "brevidadeMedia": "Média",
    "brevidadeMediaAjuda": "Objetiva, sem alongar.",
    "brevidadeDetalhada": "Detalhada",
    "brevidadeDetalhadaAjuda": "Explica com mais profundidade. Cabe em e-mail, não em WhatsApp.",
    "formalidade": "Tom",
    "formalidadeInformal": "Informal",
    "formalidadeCordial": "Cordial",
    "formalidadeFormal": "Formal",
    "aviso": "Aviso de automação",
    "avisoAjuda": "Primeira mensagem do canal: informa que é assistente e como falar com uma pessoa.",
    "setor": "Setor de escalonamento",
    "ativoRotulo": "Assistente ativo",
    "previaTitulo": "Prompt final",
    "previaDescricao": "O texto exato que o modelo recebe, já com as frases geradas a partir dos parâmetros.",
    "previaFalhou": "Não foi possível montar a pré-visualização.",
    "caracteres": "{{total}} caracteres",
    "regrasQueGeraram": "Regras que geraram estas frases",
    "historicoDoPrompt": "Histórico do prompt ({{total}} versões)",
    "origemAlteracaoDoAssistente": "cadastro alterado",
    "origemAlteracaoDeParametro": "parâmetro alterado",
    "origemDetectada": "diferença notada",
    "semAutor": "sem autor registrado",
    "compararComAtual": "Comparar com o atual",
    "diferencaResumo": "Da v{{versao}} para o prompt de agora: {{entraram}} linha(s) entraram, {{sairam}} saíram.",
    "novo": "Novo assistente",
    "novoDescricao": "Uma identidade nova para a marca {{marca}}.",
    "identidade": "Identidade e comportamento",
    "criar": "Criar assistente",
    "canalAjuda": "Um assistente atende vários canais. Marque todos por onde ele responde.",
    "canalExistente": "Canal",
    "criarCanal": "— criar um canal novo —",
    "canalNome": "Nome do canal",
    "canalId": "Número da caixa no Chatwoot",
    "canalIdAjuda": "O inbox_id. Aparece na URL quando você abre a caixa no Chatwoot.",
    "canalTipo": "Como o cliente é identificado neste canal",
    "inbox": "caixa {{id}}",
    "jaOcupado": "já é de {{nome}}",
    "tipoTelefone": "Telefone (WhatsApp)",
    "tipoTelegram": "Telegram",
    "tipoInstagram": "Instagram",
    "tipoEmail": "E-mail",
    "tipoSite": "Site (chat do site)",
    "pedeTelefone": "Este canal não entrega o telefone do cliente. O assistente vai pedir o número durante a conversa — no WhatsApp, não pede.",
    "papel": "Papel na operação",
    "papelAjuda": "O que este assistente é. Define o que ele pode escrever.",
    "papelAtendimento": "Atendimento — fala com o cliente no canal",
    "papelInterno": "Interno — canal próprio, não fala com cliente final",
    "papelCopiloto": "Copiloto — só nota privada, sem canal",
    "papelCopilotoAviso": "O copiloto não tem canal e escreve apenas notas privadas, dentro da conversa de outro assistente. Ele precisa de um token próprio na plataforma: sem token, não escreve.",
    "token": "Token de autoria na plataforma",
    "tokenAjuda": "É com ele que a plataforma sabe de quem é a mensagem. Sem token próprio, o assistente assina pelo token do sistema.",
    "tokenGravado": "Token próprio cadastrado (final {{fim}})",
    "tokenAdministrativo": "Assina pelo token do sistema",
    "tokenAusente": "Nenhum token configurado",
    "tokenGravar": "Gravar token",
    "tokenConferir": "Conferir de quem é",
    "tokenApagar": "Remover token próprio",
    "tokenDono": "Token de: {{dono}}",
    "avisoPadrao": "O aviso de que o atendimento é automatizado é preenchido automaticamente. Dá para ajustar depois, na edição.",
    "semCanalCadastrado": "Nenhum canal cadastrado nesta marca",
    "semSetor": "Sem setor padrão",
    "semTimeSincronizado": "Nenhum time sincronizado com o Chatwoot ainda. Sincronize em Times para escolher o setor.",
    "destaquesDoResumo": "Destaques do resumo do painel",
    "destaquesDoResumoAjuda": "O que o resumo do contato deve destacar para o atendente. Não entra no prompt do atendimento. Em branco, usa o padrão de fábrica.",
    "temperatura": "Temperatura do modelo (0,0 a 1,0)",
    "temperaturaAjuda": "Quanta variedade a assistente tem na redação. Mais alta deixa o texto menos repetitivo — e aumenta o risco de ela inventar dado. Mais baixa deixa a resposta mais previsível e mais segura. O padrão é 0,30.",
    "maximoDeTokens": "Tamanho máximo da resposta (tokens)",
    "maximoDeTokensAjuda": "Teto de cada resposta. Muito baixo corta a mensagem no meio da frase; muito alto encarece sem melhorar. O padrão é 1.500."
  },
  "simulacao": {
    "titulo": "Simulação de orçamento",
    "descricao": "Monte uma especificação e veja o preço com a memória de cálculo aberta, sem passar por conversa.",
    "semTabela": "Nenhuma versão da tabela de preços foi carregada ainda.",
    "especificacao": "Especificação",
    "tiragem": "Tiragem",
    "paginas": "Páginas",
    "formato": "Formato",
    "papel": "Papel do miolo",
    "laminacao": "Laminação",
    "semLaminacao": "Sem laminação",
    "laminacaoFosca": "Fosca ou brilho",
    "laminacaoSoft": "Soft touch",
    "orelhas": "Com orelhas",
    "capa44": "Capa 4/4 (frente e verso)",
    "shrink": "Shrink individual",
    "outraBrochura": "Outra brochura (não é livro)",
    "versao": "Versão da tabela",
    "versaoVigente": "Versão vigente",
    "versaoItem": "v{{numero}} — vigente desde {{data}}",
    "praticado": "Valor praticado",
    "praticadoAjuda": "Informe o valor de um orçamento real para comparar. Deixe em branco para só simular.",
    "calcular": "Calcular",
    "resultado": "Resultado",
    "aindaNaoCalculou": "Preencha a especificação e clique em calcular.",
    "total": "Total",
    "unitario": "Preço unitário",
    "versaoUsada": "Versão",
    "memoria": "Memória de cálculo",
    "memoriaAjuda": "Cada linha com a sua origem. É o que sustenta o preço diante do cliente.",
    "memoriaLegenda": "Memória de cálculo do orçamento, etapa por etapa.",
    "etapa": "Etapa",
    "linha": "Item",
    "valor": "Valor",
    "abaixo": "O cálculo está {{percentual}}% abaixo do praticado",
    "acima": "O cálculo está {{percentual}}% acima do praticado",
    "diferencaCorpo": "Calculado: {{calculado}} · Praticado: {{praticado}} · Diferença: {{diferenca}}",
    "escalonar": {
      "Generico": "Este caso segue por atendimento humano — o assistente não fecha o preço sozinho.",
      "CapaDura": "Livro em capa dura vai sempre para atendimento humano.",
      "Caixa": "Fabricação de caixa segue cotação manual do comercial.",
      "TiragemColoridaAcimaDoLimite": "Tiragem colorida acima do limite configurado vai para atendimento humano.",
      "PrazoOuPagamento": "Prazo, pagamento, desconto e parcelamento são sempre tratados por uma pessoa.",
      "TiragemAbaixoDoMinimo": "Tiragem abaixo do mínimo para livro."
    }
  },
  "orcamentos": {
    "titulo": "Orçamentos",
    "legenda": "Orçamentos do período, com produto, contato, canal, valores e os links para a conversa e para o contato.",
    "vazio": "Nenhum orçamento calculado ainda.",
    "numero": "Número interno",
    "referencia": "Referência da planilha",
    "semReferencia": "sem referência",
    "quando": "Quando",
    "abrir": "Abrir",
    "voltar": "Voltar à lista",
    "simular": "Nova simulação",
    "calculadoEm": "Calculado em {{quando}}, com a versão {{versao}} da tabela.",
    "entrada": "Especificação usada",
    "reproduz": "Recalculado agora com a versão que ele guardou, o valor bate com o original.",
    "naoReproduzTitulo": "O valor não é mais reproduzível",
    "naoReproduz": "Recalcular com a versão que este orçamento guardou não devolve o valor original. Alguma coisa mudou que não deveria ter mudado — não use este orçamento como referência antes de investigar.",
    "excluido": "Este orçamento foi excluído. Ele continua no histórico para consulta.",
    "descricaoDaLista": "O que foi orçado no período, para quem, e o caminho para a conversa.",
    "vazioFiltrado": "Nenhum orçamento com estes filtros. Experimente aumentar o período.",
    "produto": "Produto",
    "resumo": "O que foi orçado",
    "contato": "Contato",
    "canal": "Canal",
    "assistente": "Assistente",
    "filtros": "Filtros dos orçamentos",
    "periodo": "Período",
    "atalho": {
      "hoje": "Hoje",
      "seteDias": "7 dias",
      "esteMes": "Este mês"
    },
    "de": "De",
    "ate": "Até",
    "todos": "Todos",
    "busca": "Buscar",
    "buscaExemplo": "Número, referência ou nome do contato",
    "limpar": "Limpar filtros",
    "exportar": "Exportar CSV",
    "exportacaoFalhou": "Não foi possível gerar a planilha. Tente de novo em instantes.",
    "exportacaoParcial": "A planilha leva os {{teto}} orçamentos mais recentes do filtro. Para levar todos, diminua o período.",
    "repetido": "repetido",
    "repetidoAjuda": "Há outro orçamento igual (mesmo produto, tiragem e total) na mesma conversa.",
    "excluidoSelo": "excluído",
    "abrirConversa": "Abrir conversa",
    "abrirConversaDe": "Abrir a conversa {{conversa}} do orçamento {{numero}}, em nova aba",
    "abrirContato": "Abrir contato",
    "abrirContatoDe": "Abrir o contato {{contato}} do orçamento {{numero}}, em nova aba",
    "quantidade_one": "{{count}} orçamento no período",
    "quantidade_other": "{{count}} orçamentos no período",
    "soma": "Soma: {{soma}}",
    "foraDaSoma_one": "{{count}} excluído fora da soma",
    "foraDaSoma_other": "{{count}} excluídos fora da soma",
    "paginacao": "Páginas da lista",
    "anterior": "Anterior",
    "proxima": "Próxima",
    "pagina": "Página {{pagina}} de {{paginas}}",
    "quantidade_zero": "Nenhum orçamento no período",
    "semNomeCadastrado": "sem nome cadastrado",
    "abrirContatoSemNomeDe": "Abrir o contato do orçamento {{numero}}, em nova aba",
    "filtroRecusado": "Não foi possível usar estes filtros"
  },
  "conhecimento": {
    "titulo": "Base de conhecimento",
    "descricao": "O que o assistente da {{marca}} sabe responder sem inventar.",
    "novo": "Novo documento",
    "documento": "Documento",
    "documentos": "Documentos",
    "assistente": "Assistente",
    "todos": "Todos",
    "tituloDoDocumento": "Título",
    "origem": "Origem",
    "origemAjuda": "De onde veio: tabela de preços, decisão do cliente de 22/06, site.",
    "referencia": "Referência",
    "conteudo": "Conteúdo",
    "trechos": "Trechos",
    "trecho": "Trecho {{ordem}}",
    "vazio": "Nenhum documento ainda.",
    "legenda": "Documentos da base de conhecimento, com situação e número de trechos indexados.",
    "situacaoRascunho": "Rascunho",
    "situacaoPublicado": "Publicado",
    "situacaoArquivado": "Arquivado",
    "formularioDescricao": "Publicar é o que coloca o texto ao alcance do assistente.",
    "publicar": "Publicar",
    "publicado": "Publicado em {{trechos}} trecho(s).",
    "semMudanca": "O texto não mudou desde a última publicação — nada foi reindexado.",
    "piiMascarada": "{{total}} ocorrência(s) de dado pessoal foram mascaradas.",
    "precisaRepublicar": "As alterações foram salvas, mas o índice ainda tem o texto anterior. Publique para o assistente passar a usar o novo.",
    "nadaPublicado": "Nenhum documento publicado. O assistente conversa normalmente, mas sobre catálogo vai responder que precisa verificar.",
    "comoFicouIndexado": "Como ficou indexado",
    "indexadoDescricao": "O texto exato que a busca alcança — já com dado pessoal mascarado.",
    "semTrechos": "Ainda não publicado.",
    "buscaTitulo": "Testar a busca",
    "buscaDescricao": "Veja o que o assistente encontraria antes de ele responder a um cliente.",
    "pergunta": "Pergunta",
    "perguntaAjuda": "Escreva como um cliente escreveria: couché 150g, capa dura, quanto custa 1000 panfletos.",
    "buscaVazia": "Nada foi encontrado para esta pergunta. O assistente diria que vai verificar.",
    "lexicalEm": "termo literal: {{posicao}}º",
    "lexicalNao": "termo literal: não achou",
    "vetorialEm": "sentido: {{posicao}}º",
    "vetorialNao": "sentido: não achou",
    "importar": "Importar arquivo",
    "importarDescricao": "Um arquivo Markdown curado. Cada título de nível 2 vira um documento.",
    "arquivo": "Arquivo (.md)",
    "importaComoRascunho": "Os documentos entram como rascunho. Nada vai para o assistente antes de alguém publicar.",
    "importados": "{{criados}} documento(s) criados de {{secoes}} seção(ões).",
    "tituloDoPdf": "Título (só para PDF)",
    "tituloDoPdfDica": "Em branco, usa o nome do arquivo. O markdown ignora este campo — ele cria um documento por seção.",
    "pdfImportado": "PDF importado: \"{{titulo}}\" — {{paginas}} página(s), {{caracteres}} caracteres de texto.",
    "pdfDigitalizado": "PDF é lido aqui mesmo, sem sair do servidor. PDF digitalizado (só imagem) é recusado com o motivo, em vez de virar documento vazio."
  },
  "painel": {
    "titulo": "Painel",
    "periodo": "Últimas 24 horas — {{de}} até {{ate}}",
    "sinalDeVida": "Sinal de vida",
    "semIndicadores": "Nenhum indicador registrado.",
    "situacaoVerde": "Tudo em ordem",
    "situacaoAtencao": "Merece atenção",
    "situacaoVermelho": "Alguma coisa parou",
    "situacaoDesconhecida": "Sem dados suficientes",
    "enviarResumo": "Enviar resumo agora",
    "resumoEnviado": "Resumo enviado. Confira a caixa de entrada.",
    "resumoFalhou": "Não foi possível enviar. Confira os destinatários e a configuração de e-mail.",
    "metricas": "Métricas da operação",
    "escolherPeriodo": "Escolher período",
    "dias": "{{dias}} dias",
    "conversas": "Conversas",
    "mensagens": "Mensagens",
    "foraDoHorario": "Fora do horário comercial",
    "foraDoHorarioDetalhe": "{{total}} conversas",
    "transbordo": "Foram para humano",
    "transbordoDetalhe": "{{total}} transbordos",
    "primeiraResposta": "Até a 1ª resposta",
    "primeiraRespostaDetalhe": "mediana",
    "custoPorConversa": "Custo por conversa",
    "custoTotal": "{{total}} no período",
    "segundos": "{{total}}s",
    "minutos": "{{total}} min",
    "horas": "{{horas}}h {{minutos}}min",
    "porCanal": "Por canal",
    "porCanalLegenda": "Conversas e mensagens por canal e marca.",
    "canal": "Canal",
    "motivosDeTransbordo": "Por que foram para humano",
    "semTransbordo": "Nenhum transbordo no período.",
    "porDia": "Por dia",
    "porDiaLegenda": "Conversas e mensagens por dia.",
    "dia": "Dia",
    "notasDoCopiloto": "Notas do copiloto",
    "notasDoCopilotoDetalhe": "Sugestões escritas ao atendente nas últimas 24 horas",
    "canais": {
      "titulo": "Canais",
      "conferirAgora": "Conferir agora",
      "conferido": "Conferência feita agora.",
      "jaConferindo": "Já havia uma conferência em andamento. O que está na tela é o último resultado gravado.",
      "conferirFalhou": "Não foi possível conferir agora. O que está na tela é o último resultado gravado.",
      "semPermissaoParaConferir": "Seu perfil vê a situação dos canais, mas não pode mandar conferir.",
      "nenhum": "Nenhum canal cadastrado.",
      "foraDoArTitulo_one": "{{count}} canal fora do ar",
      "foraDoArTitulo_other": "{{count}} canais fora do ar",
      "alertaDesligado": "O alerta por e-mail está desligado: a situação continua sendo conferida e mostrada aqui, mas ninguém é avisado quando um canal cai.",
      "semAssistente": "sem assistente",
      "oQueFazer": "O que fazer:",
      "alertaNaoEnviado": "Alerta não enviado: {{motivo}}",
      "avisoEnviado": "Administradores avisados por e-mail em {{quando}}",
      "ultimaRecebida": "Última recebida {{ha}}",
      "ultimaEnviada": "Última enviada {{ha}}",
      "nuncaRecebeu": "Nenhuma mensagem recebida",
      "nuncaEnviou": "Nenhuma mensagem enviada",
      "conferidoEm": "Conferido em {{quando}}",
      "haInstantes": "há instantes",
      "haMinutos": "há {{total}} min",
      "haHoras": "há {{total}} h",
      "haDias": "há {{total}} dias"
    }
  },
  "transbordo": {
    "PedidoDoCliente": "O cliente pediu atendente",
    "ForaDeEscopo": "Fora do escopo",
    "AssuntoDaEquipe": "Assunto tratado pela equipe",
    "ComprovanteDePagamento": "Comprovante de pagamento enviado pelo cliente",
    "RegraDeNegocio": "Regra de negócio",
    "BaixaConfianca": "Baixa confiança",
    "FalhaRepetida": "Falha repetida",
    "DegradacaoDaIa": "IA indisponível",
    "TravaDeSeguranca": "Trava de segurança"
  },
  "roteamento": {
    "titulo": "Roteamento do transbordo",
    "descricao": "Para onde vai a conversa quando o assistente passa para uma pessoa.",
    "times": "Times",
    "timesRotulo": "Times disponíveis",
    "timesAjuda": "Separados por vírgula. Precisam existir no Chatwoot com o mesmo nome.",
    "timesExplicacao": "Esta lista é o que o assistente pode escolher. Time fora dela não existe para ele — é assim que se impede o modelo de inventar departamento.",
    "timesPadrao": "Ainda não configurado: a lista mostrada é o padrão do sistema.",
    "destinos": "Destinos",
    "escopo": "Vale para",
    "todosOsAssistentes": "Todos os assistentes",
    "legenda": "Motivo do transbordo e time de destino.",
    "quando": "Quando",
    "vaiPara": "Vai para",
    "padrao": "padrão",
    "destinoDe": "Destino de: {{motivo}}",
    "foraDaLista": "{{time}} (fora da lista)",
    "salvo": "{{total}} alteração(ões) salvas.",
    "semMudanca": "Nada mudou."
  },
  "contexto": {
    "falhou": "Não foi possível carregar o contexto.",
    "semContato": "Ainda não conheço este contato.",
    "semContatoDica": "Ele aparece aqui depois da primeira mensagem processada pelo sistema.",
    "semNome": "Sem nome",
    "desde": "cliente desde {{data}}",
    "conversas": "{{total}} conversa(s)",
    "conversasRecentes": "Conversas recentes",
    "mensagens": "{{total}} mensagens",
    "pausada": "com humano",
    "ia": {
      "rotulo": "Estado da IA nesta conversa",
      "atendendo": "✓ IA atendendo esta conversa",
      "calada": "⏸ IA calada",
      "vaiParar": "⏸ IA prestes a parar",
      "ate": "até {{ate}}",
      "quando": "{{hora}} de {{dia}}",
      "dia": {
        "hoje": "hoje",
        "amanha": "amanhã",
        "ontem": "ontem"
      },
      "motivo": {
        "SilencioPorFalaHumana": {
          "esta": "Uma pessoa da equipe respondeu nesta conversa às {{desde}}. Para não falar por cima dela, a IA fica em silêncio por um tempo.",
          "outra": "Uma pessoa da equipe respondeu a este contato em outra conversa (nº {{conversa}}) às {{desde}}. Para não falar por cima dela, a IA fica em silêncio também nesta."
        },
        "PausadaPorTransferencia": {
          "comTime": "A conversa foi passada para {{time}} às {{desde}} ({{detalhe}}). Desde então quem responde é uma pessoa.",
          "semTime": "A conversa foi passada para uma pessoa às {{desde}} ({{detalhe}}). Desde então quem responde é uma pessoa."
        },
        "PausadaPorTrava": "A proteção contra conversa entre robôs parou a IA aqui: {{detalhe}}.",
        "TravaDeLaco": "A próxima mensagem do cliente aciona a proteção contra conversa entre robôs, e a IA para: {{detalhe}}.",
        "EtiquetaNaConversa": "Esta conversa tem a etiqueta que tira a IA (nao-atender-por-ia).",
        "EtiquetaNoContato": "Este contato tem a etiqueta que tira a IA (nao-atender-por-ia). Vale para todas as conversas dele.",
        "NumeroDaCasa": "Este contato é um número da própria casa, e a IA não conversa com ele.",
        "CaixaDesligada": "A IA está desligada neste canal.",
        "SemAssistente": "Nenhuma assistente ativa atende este canal.",
        "desconhecido": "A IA não vai responder nesta conversa. {{detalhe}}"
      },
      "como": {
        "PausadaPorTransferencia": "Ela não volta sozinha. Para devolver a conversa à IA, atribua a conversa à assistente.",
        "PausadaPorTrava": "Ela não volta sozinha. Para devolver a conversa à IA, atribua a conversa à assistente.",
        "TravaDeLaco": "Se for mesmo um cliente, responda você; depois, para devolver à IA, atribua a conversa à assistente.",
        "EtiquetaNaConversa": "Para a IA voltar, retire a etiqueta da conversa.",
        "EtiquetaNoContato": "Para a IA voltar, retire a etiqueta do contato.",
        "CaixaDesligada": "Para ligar, ative o canal em Canais, no portal.",
        "SemAssistente": "Confira a assistente da marca no portal."
      },
      "liberar": "Liberar a IA",
      "confirmarLiberar": "A IA volta a responder a este contato nesta conversa. Confirmar?",
      "liberarConfirmado": "Liberar",
      "liberando": "Liberando…",
      "proximaMensagem": "A IA volta a responder na próxima mensagem do cliente.",
      "liberadaPor": "Liberada por {{nome}} às {{quando}}",
      "falhou": "Não foi possível liberar a IA agora. Tente de novo.",
      "pausar": "Pausar a IA",
      "confirmarPausar_one": "A IA para de responder a este contato por {{count}} hora, como se uma pessoa da equipe tivesse respondido agora. Confirmar?",
      "confirmarPausar_other": "A IA para de responder a este contato por {{count}} horas, como se uma pessoa da equipe tivesse respondido agora. Confirmar?",
      "pausarConfirmado": "Pausar",
      "pausando": "Pausando…",
      "pausadaAgora": "Você pausou a IA nesta conversa. Ela volta sozinha no horário acima, ou antes, se alguém a liberar.",
      "falhouPausar": "Não foi possível pausar a IA agora. Tente de novo."
    },
    "pausa": {
      "cliente": "⏸ o cliente pediu atendente",
      "falha": "⚠ parou por falha do assistente",
      "regra": "⏸ regra da casa — precisa de pessoa",
      "naoSei": "⏸ pausada — motivo não registrado"
    },
    "orcamentos": "Orçamentos",
    "semReferencia": "sem referência",
    "tiragem": "{{total}} un.",
    "transbordos": "Passagens para humano",
    "enviados": "Enviado pelo assistente",
    "nada": "Nada por aqui.",
    "tipoTelefone": "telefone",
    "tipoEmail": "e-mail",
    "tipoCpfCnpj": "CPF/CNPJ",
    "tipoTelegram": "Telegram",
    "tipoInstagram": "Instagram",
    "envioTexto": "Mensagem",
    "envioNotaPrivada": "Nota interna",
    "envioAnexo": "Anexo",
    "envioAnexoPrivado": "Anexo interno",
    "envioQuadroDoOrcamento": "Quadro do orçamento",
    "resumoTitulo": "Resumo do cliente",
    "resumoCarregando": "Redigindo o resumo…",
    "resumoSemBase": "Ainda não há histórico suficiente para resumir. Os fatos abaixo são tudo o que se sabe.",
    "resumoIndisponivel": "O resumo não está disponível agora. Os fatos abaixo continuam completos.",
    "resumoNaoEFonte": "Redigido por IA sobre os fatos abaixo. Serve para você se situar — não é fonte para responder ao cliente: confira nos fatos antes de repassar qualquer coisa.",
    "turnoTitulo": "O que o assistente recebe nesta conversa",
    "turnoFalhou": "Não consegui montar o contexto do assistente agora.",
    "turnoSemConversa": "Este contato ainda não tem conversa no sistema novo.",
    "turnoMontadoAgora": "Montado agora, do mesmo jeito que o {{assistente}} recebe ({{modelo}}) — não é um retrato guardado turno a turno.",
    "turnoVersao": "Versão {{versao}} do prompt no último turno",
    "turnoPromptMudou": "o prompt mudou depois",
    "papelSistema": "sistema",
    "papelUsuario": "cliente",
    "papelAssistente": "assistente",
    "papelFerramenta": "ferramenta"
  },
  "tabela": {
    "titulo": "Tabela de preços",
    "descricao": "Cada carga vira uma versão. É o que permite recalcular um orçamento antigo e chegar ao mesmo valor.",
    "carregar": "Carregar planilha",
    "planilha": "Planilha (.xlsx)",
    "planilhaAjuda": "Arraste a planilha. O portal reconhece qual das três é pelo conteúdo — não pelo nome do arquivo.",
    "conferir": "Conferir",
    "recusada": "A planilha não pode ser carregada assim:",
    "lida": "Planilha lida: {{formatos}} formatos, {{miolo}} papéis de miolo, {{capa}} papéis de capa.",
    "formatosSumidos": "Estes formatos existem na tabela atual e sumiram na nova: {{formatos}}. Orçamentos deles passarão a falhar.",
    "formatosNovos": "Formatos novos: {{formatos}}.",
    "mudancasLegenda": "O que muda em relação à tabela vigente.",
    "campo": "Custo",
    "de": "Hoje",
    "para": "Na planilha",
    "semMudancaDeCusto": "Nenhum custo geral mudou em relação à tabela vigente.",
    "observacao": "Observação",
    "observacaoAjuda": "O que mudou e por quê. Aparece no histórico.",
    "vigenteDe": "Vigente de",
    "vigenteDeAjuda": "Em branco vale a partir de agora. Permite preparar uma alta de preço com antecedência.",
    "criarVersao": "Criar versão",
    "carregada": "Versão v{{numero}} da {{formato}} criada.",
    "somenteCtgf": "Só a CTGF pode criar versão da tabela.",
    "versoes": "Versões",
    "versoesLegenda": "Cargas da tabela de preços, da mais recente para a mais antiga.",
    "versao": "Versão",
    "carregadaPor": "Carregada por",
    "arquivo": "Arquivo",
    "impressao": "Impressão",
    "semVersao": "Nenhuma versão carregada. A simulação usa os valores padrão.",
    "recusadaNoFormato": "Reconheci a planilha como {{formato}}, e ela não pode ser carregada assim:",
    "abasEncontradas": "Abas encontradas no arquivo: {{abas}}.",
    "reconhecida": "Reconhecida como {{formato}}",
    "resumoDaGrade": "{{familias}} famílias, {{itens}} itens e {{variantes}} variantes de papel. {{codigos}} códigos de orçamento do GE e {{tolerancias}} itens com tolerância de medida declarada.",
    "resumoDeLivros": "{{formatos}} formatos de livro, com preço fixo inicial de R$ {{custoFixo}}.",
    "achados": "Conferência de conformidade: {{total}} achado(s)",
    "bloqueia": "[recusa]",
    "soAviso": "[aviso]",
    "semVersaoDoFormato": "Nenhuma versão carregada deste formato.",
    "versoesLegendaDe": "Cargas de {{formato}}, da mais recente para a mais antiga.",
    "formato": {
      "Grade": "Grade por família",
      "Livros": "Fórmula de livros (digital/POD)",
      "Offset": "Calculadora de offset"
    },
    "formatoAjuda": {
      "Grade": "Tabela de Preços IA — uma aba por família, com a grade formato × papel × quantidade.",
      "Livros": "Formação de Preço Loja — a fórmula-mestra do livro digital, com tiragem contínua.",
      "Offset": "calculadora_precos_offset_v2 — livro colorido em offset. Substitui a antiga \"300 ou mais Livros Coloridos\"."
    }
  },
  "painelEmbutido": {
    "falhou": "Não foi possível abrir o painel.",
    "semToken": "Este painel não foi configurado com um token de instalação.",
    "semTokenDica": "Quem administra o Chatwoot precisa acrescentar ?inst=<token> ao endereço do aplicativo.",
    "semAgente": "Não consegui identificar quem está usando o Chatwoot.",
    "semAgenteDica": "O painel precisa saber quem é você para registrar o acesso ao histórico do cliente. Recarregue a conversa; se continuar, avise quem administra o portal."
  },
  "nav": {
    "rotulo": "Navegação do portal",
    "abrirMenu": "Abrir o menu",
    "inicio": "Início",
    "marcas": "Marcas",
    "semMarca": "Nenhuma marca cadastrada.",
    "cadastrarMarca": "Cadastrar a primeira",
    "times": "Times",
    "regras": "Regras do cliente",
    "chaves": "Chaves de IA",
    "transporte": "Transportadoras",
    "ajuda": "Ajuda",
    "modelosWhatsapp": "Modelos de WhatsApp"
  },
  "regras": {
    "titulo": "Regras do cliente",
    "descricao": "As decisões da Rio DG que o assistente precisa respeitar. O mesmo valor é imposto pelo motor e explicado no prompt.",
    "gerais": "Valem para todos os assistentes",
    "geraisAjuda": "Um assistente pode sobrescrever qualquer uma delas na própria tela.",
    "noAssistente": "Regras do cliente neste assistente",
    "noAssistenteAjuda": "O valor efetivo aqui. Alterar cria uma sobrescrita que vale só para este assistente; \"usar o valor geral\" a remove.",
    "vazio": "Nenhuma regra cadastrada.",
    "somenteLeitura": "Seu perfil vê as regras, mas não as altera.",
    "valor": "Valor",
    "ligada": "Ligada",
    "desligada": "Desligada",
    "novoTermo": "Novo termo",
    "adicionar": "Adicionar",
    "removerTermo": "Remover {{termo}}",
    "naoAceitaVazio": "Esta lista não pode ficar vazia: o motor depende dela para reconhecer o pedido.",
    "usarOGeral": "Usar o valor geral",
    "confirmarDesligar": "Ao desligar esta regra, {{efeito}}.\n\nConfirma?",
    "geralVale": "geral: {{valor}}",
    "porAutor": "por {{autor}}",
    "procedencia": {
      "Padrao": "padrão do sistema",
      "Geral": "valor geral",
      "Assistente": "sobrescrito aqui"
    },
    "nome": {
      "regra.capa_dura_para_humano": "Capa dura vai para humano",
      "regra.caixa_fluxo_separado": "Caixa segue fluxo separado",
      "regra.prazo_pagamento_desconto_para_humano": "Prazo, pagamento e desconto com humano",
      "regra.colorido.tiragem_maxima_automatica": "Tiragem colorida máxima automática",
      "regra.livro.tiragem_minima": "Tiragem mínima de livro",
      "regra.familia_livros": "Materiais da família Livros",
      "regra.cores_equivalentes_a_colorido": "Termos que significam colorido",
      "regra.pedir_telefone_por_canal": "Canais em que se pede o telefone",
      "regra.cotacao.validade_dias": "Validade da proposta (dias corridos)",
      "regra.prazo_fabricacao_dias": "Prazo de fabricação (DIAS CORRIDOS) — 0 = não informado",
      "regra.silencio_apos_humano_horas": "Silêncio da IA depois que uma pessoa fala (HORAS) — 0 = desligado"
    }
  },
  "modelo": {
    "titulo": "Provedor e modelo",
    "descricao": "Qual modelo este assistente usa, a reserva para quando ele falhar, e os tetos de custo.",
    "somenteLeitura": "Escolher modelo é decisão de custo e comportamento: seu perfil não altera.",
    "provedor": "Provedor",
    "modelo": "Modelo",
    "provedorDeReserva": "Provedor de reserva",
    "modeloDeReserva": "Modelo de reserva",
    "semReserva": "Sem reserva",
    "tetoPorConversa": "Teto por conversa (US$)",
    "tetoPorDia": "Teto por dia (US$)",
    "provedorSemChave": "{{provedor}} — sem chave cadastrada",
    "semChave": "O provedor {{provedor}} não tem chave cadastrada. Cadastre-a em Chaves de IA antes de apontar o assistente para ele — sem chave, a conversa cai para humano e a causa fica escondida.",
    "reservaNoMesmoProvedor": "A reserva está no mesmo provedor do primário. Isso cobre modelo indisponível, mas não cobre credencial recusada nem falta de saldo, que derrubam os dois ao mesmo tempo.",
    "salvo": "Modelo salvo. A próxima conversa já usa o novo."
  },
  "marcas": {
    "titulo": "Marcas",
    "descricao": "Cada marca do grupo tem os próprios canais, assistentes e preços.",
    "nova": "Nova marca",
    "editar": "Editar",
    "nome": "Nome",
    "chave": "Chave",
    "chaveDerivada": "A chave é derivada do nome e não muda depois.",
    "chaveNaoMuda": "A chave não muda: ela está em endereços e em orçamentos já gravados.",
    "telefone": "Telefone",
    "telefoneAjuda": "Número do WhatsApp da marca, com código do país.",
    "ativa": "Marca ativa",
    "ativaSim": "Ativa",
    "ativaNao": "Inativa",
    "canais": "Canais",
    "situacao": "Situação",
    "acoes": "Ações",
    "salvar": "Salvar",
    "cancelar": "Cancelar",
    "legenda": "Marcas cadastradas, com chave, telefone e número de canais.",
    "carregando": "Carregando as marcas…",
    "vazio": "Nenhuma marca cadastrada",
    "vazioAjuda": "Cadastre a primeira marca para que ela apareça no menu.",
    "erroAoCarregar": "Não foi possível carregar as marcas",
    "erroAoSalvar": "Não foi possível salvar a marca.",
    "tentarDeNovo": "Tentar de novo"
  },
  "times": {
    "titulo": "Times de atendimento",
    "descricao": "Para onde o assistente encaminha. A lista vem do Chatwoot; a descrição é daqui.",
    "sincronizar": "Sincronizar com o Chatwoot",
    "sincronizado": "{{criados}} novo(s), {{atualizados}} atualizado(s), {{ausentes}} ausente(s).",
    "sincronizacaoFalhou": "Não foi possível sincronizar agora — {{erro}}. A última lista continua valendo.",
    "ultimaSincronizacao": "Última sincronização: {{quando}}",
    "nuncaSincronizado": "Nunca sincronizado com o Chatwoot.",
    "ausente": "ausente no Chatwoot",
    "ausenteAjuda": "Este time sumiu do Chatwoot. Ele não é mais oferecido ao assistente, mas continua aqui porque pode haver regra de roteamento apontando para ele.",
    "descricaoDoTime": "O que este time atende",
    "descricaoAjuda": "Escreva em português corrido: é o que o assistente lê para escolher o destino. Ex.: segunda via de boleto, nota fiscal, cobrança.",
    "semDescricao": "Sem descrição — o assistente não tem como escolher este time por assunto.",
    "editarDescricao": "Editar",
    "destino": "Recebe atendimento automático",
    "destinoAjuda": "Quando ligado, este time entra na lista fechada que vai ao assistente e pode receber um encaminhamento automático. Desligue os setores internos e os que só atendem fornecedor — eles continuam recebendo transferência manual.",
    "foraDoAutomatico": "fora do atendimento automático",
    "foraDoAutomaticoAjuda": "Este time não é oferecido ao assistente. Ele continua existindo, aparece aqui e recebe transferência feita por uma pessoa.",
    "nenhumDestino": "Nenhum time está marcado para receber atendimento automático. Enquanto for assim, o assistente não consegue escolher o setor e todo encaminhamento cai na tabela de roteamento.",
    "destinoFalhou": "Não foi possível salvar. Tente de novo.",
    "salvar": "Salvar",
    "cancelar": "Cancelar",
    "carregando": "Carregando os times…",
    "vazio": "Nenhum time sincronizado",
    "vazioAjuda": "Sincronize com o Chatwoot para trazer os times da conta.",
    "erroAoCarregar": "Não foi possível carregar os times",
    "tentarDeNovo": "Tentar de novo"
  },
  "chaves": {
    "titulo": "Chaves dos provedores de IA",
    "descricao": "A conta é do cliente. A chave fica cifrada no cofre do portal, não em arquivo.",
    "nuncaVolta": "A chave nunca é devolvida por esta tela — só os quatro últimos caracteres, para você conferir o que colou.",
    "configurada": "configurada · …{{fim}} · {{origem}}",
    "naoConfigurada": "não configurada",
    "origem": {
      "portal": "no cofre",
      "arquivo": "no arquivo"
    },
    "vemDoArquivo": "Esta chave vem do arquivo de configuração, não do cofre. Trocá-la ainda exige acesso à máquina — salve aqui para que ela passe a viver cifrada no portal.",
    "nova": "Nova chave para {{provedor}}",
    "vazioMantem": "Deixe em branco para manter a chave atual.",
    "salvar": "Salvar chave",
    "salva": "Chave do {{provedor}} guardada no cofre.",
    "apagar": "Apagar do cofre",
    "apagada": "Chave do {{provedor}} apagada do cofre.",
    "carregando": "Carregando os provedores…",
    "erroAoCarregar": "Não foi possível carregar os provedores",
    "tentarDeNovo": "Tentar de novo",
    "testar": "Testar chave"
  },
  "transporte": {
    "titulo": "Credenciais das transportadoras",
    "descricao": "Correios, Braspress e PrintOne. O segredo fica cifrado no cofre do portal, não em arquivo.",
    "nuncaVolta": "O segredo nunca é devolvido por esta tela — só os quatro últimos caracteres, para você conferir o que colou. Usuário, CNPJ, CEP e cartão de postagem aparecem inteiros de propósito, para dar para conferir o cadastro.",
    "configurado": "configurado · …{{fim}} · {{origem}}",
    "naoConfigurado": "não configurado",
    "desabilitado": "desligada",
    "origem": {
      "portal": "no cofre",
      "arquivo": "no arquivo"
    },
    "vemDoArquivo": "Esta credencial vem do arquivo de configuração, não do cofre. Trocá-la ainda exige acesso à máquina — salve aqui para que ela passe a viver cifrada no portal.",
    "vazioMantem": "Deixe em branco para manter o que já está guardado.",
    "habilitada": "Habilitada",
    "habilitadaAjuda": "Desligada, esta transportadora não é consultada na cotação de frete. Só dá para ligar depois que a credencial estiver completa.",
    "salvar": "Salvar credencial",
    "salvo": "Credencial da {{servico}} guardada no cofre.",
    "erroAoSalvar": "Não foi possível salvar. Confira os campos e tente de novo.",
    "testar": "Testar credencial",
    "carregando": "Carregando as transportadoras…",
    "erroAoCarregar": "Não foi possível carregar as transportadoras",
    "tentarDeNovo": "Tentar de novo",
    "nome": {
      "correios": "Correios",
      "braspress": "Braspress",
      "printone": "PrintOne"
    },
    "campo": {
      "urlbase": "URL da API",
      "usuario": "Usuário",
      "codigoacesso": "Código de acesso",
      "cartaopostagem": "Cartão de postagem",
      "cnpjremetente": "CNPJ do remetente",
      "ceporigem": "CEP de origem",
      "senha": "Senha",
      "chave": "Chave"
    },
    "ajuda": {
      "cartaopostagem": "Obrigatório. Sem o cartão de postagem a credencial autentica, mas o rastreio devolve 403 — e o erro não explica o motivo.",
      "ceporigem": "De onde as encomendas saem. É o CEP usado na cotação."
    }
  },
  "caixas": {
    "titulo": "Canais da marca",
    "descricao": "Cada canal do Chatwoot ligado a esta marca. É por este vínculo que a mensagem encontra o assistente certo.",
    "aviso": "O número do canal é como o sistema reconhece de quem é a mensagem. Se ele não bater com o Chatwoot, as mensagens chegam e são descartadas em silêncio — sem erro visível.",
    "idExterno": "Número do canal no Chatwoot",
    "idExternoAjuda": "É o \"id\" da caixa de entrada, visível na URL das configurações do canal no Chatwoot. Use \"Conferir no Chatwoot\" para não digitar.",
    "nome": "Nome",
    "tipo": "Tipo de identificador",
    "canalExterno": "Canal",
    "ativa": "Canal ativo",
    "ativaAjuda": "Desligado, as mensagens deste canal deixam de ser atendidas. O histórico é preservado.",
    "assistente": "Assistente: {{nome}}",
    "semAssistente": "Sem assistente ligado",
    "salvar": "Salvar canal",
    "salvo": "Canal atualizado.",
    "conferir": "Conferir no Chatwoot",
    "doChatwoot": "Canais no Chatwoot",
    "usarEste": "Usar este",
    "jaCadastrada": "já cadastrado",
    "semResposta": "Não consegui consultar o Chatwoot agora. Você pode digitar o número à mão.",
    "carregando": "Carregando os canais…",
    "erroAoCarregar": "Não foi possível carregar os canais",
    "tentarDeNovo": "Tentar de novo",
    "vazio": "Esta marca ainda não tem canal ligado.",
    "novo": "Novo canal",
    "novoAjuda": "Ligar um canal do Chatwoot a esta marca. Criar é diferente de editar: alterar um canal existente muda a quem ele pertence, e o canal antigo deixa de ser atendido — em silêncio.",
    "criar": "Criar canal",
    "criado": "Canal criado.",
    "tipoAjuda": "Como o cliente é reconhecido neste canal. WhatsApp identifica por telefone; Telegram e Instagram, pelo identificador da própria plataforma; o chat do site, pela sessão do navegador — o visitante é anônimo até informar o telefone.",
    "tipoTelefone": "Telefone — WhatsApp",
    "tipoBsuid": "BSUID — WhatsApp com número oculto",
    "tipoInstagram": "Instagram",
    "tipoTelegram": "Telegram",
    "tipoEmail": "E-mail",
    "tipoSite": "Site — chat do site (visitante sem telefone)"
  },
  "cotacao": {
    "titulo": "Cotação",
    "descricao": "Cota pelo motor certo: a grade das 9 famílias, a fórmula do livro digital ou a calculadora de offset. Quem escolhe é a regra, não o modelo.",
    "pedido": "O que o cliente pediu",
    "oQueOClienteDisse": "Descrição do produto",
    "oQueOClienteDisseAjuda": "Como o cliente escreveu. É daqui que saem os sinônimos comerciais e a notação de cores.",
    "tiragem": "Quantidade",
    "largura": "Largura (cm)",
    "altura": "Altura (cm)",
    "medidaAjuda": "A medida casa por tolerância, não por igualdade exata.",
    "papel": "Papel",
    "papelAjuda": "Em branco, vale o primeiro papel da linha na planilha.",
    "gramatura": "Gramatura (g/m²)",
    "livro": "Só para livro",
    "livroAjuda": "Preencha quando o pedido for livro, revista, catálogo ou apostila.",
    "paginas": "Páginas do miolo",
    "formato": "Formato comercial",
    "formatoAjuda": "Ex.: 14x21 cm. É a medida do livro, não a família.",
    "colorido": "Miolo colorido",
    "coloridoAjuda": "\"4 cores\", \"4x4\", \"2 ou 3 cores\" — todos contam como colorido.",
    "capaDura": "Capa dura",
    "capaDuraAjuda": "Sempre vai para atendimento humano, nos dois assistentes.",
    "cotar": "Cotar",
    "resultado": "Resultado",
    "aindaNao": "Preencha o pedido e clique em Cotar.",
    "vaiParaHumano": "Este pedido vai para uma pessoa",
    "porque": "Por quê: {{porque}}.",
    "unitario": "{{valor}} por unidade",
    "codigo": "Orçamento-base no sistema: código {{codigo}}.",
    "memoriaLegenda": "Como o preço foi formado, item a item.",
    "etapa": "Etapa",
    "detalhe": "Detalhe",
    "valor": "Valor",
    "versao": "Calculado com a versão v{{versao}} da tabela.",
    "motor": {
      "Grade": "Cotado pela grade por família",
      "LivroDigital": "Cotado pela fórmula do livro digital",
      "LivroOffset": "Cotado pela calculadora de offset",
      "Humano": "Vai para uma pessoa"
    }
  },
  "contatos": {
    "titulo": "Contato único",
    "descricao": "A mesma pessoa, em canais diferentes, é hoje dois cadastros. Unir o contato errado mistura o histórico de duas pessoas — por isso o sistema sugere e você confirma.",
    "semCandidatos": "Nenhum candidato a unir",
    "semCandidatosAjuda": "Só entram aqui pares com dado em comum parcial — mesmo final de telefone, mesmo e-mail. Semelhança de nome nunca é sugerida.",
    "par": "{{um}} e {{outro}}",
    "provas": "O que têm em comum: {{provas}}.",
    "verOsDoisLados": "Ver os dois lados antes de decidir",
    "identificadores": "Identificadores",
    "porCanal": "Histórico por canal",
    "semConversa": "Nenhuma conversa registrada.",
    "conversas": "{{total}} conversa(s)",
    "semNome": "Contato #{{id}}",
    "desde": "Cadastrado em {{quando}}",
    "unir": "Unir os dois",
    "confirmarUniao": "Unir {{um}} e {{outro}} junta o histórico dos dois num só contato.\n\nSe forem pessoas diferentes, o assistente passa a responder a uma com base na conversa da outra.\n\nConfirma?",
    "unidos": "Contatos unidos. Você pode desfazer a qualquer momento.",
    "manual": {
      "titulo": "Unir manualmente",
      "descricao": "Telegram e Instagram não fornecem telefone, e o identificador do Instagram é escopado por aplicativo — contatos desses canais nunca aparecem como sugestão, por falta de dado em comum. Aqui você escolhe os dois lados; a decisão é sua, e fica registrada.",
      "primeiro": "Primeiro contato",
      "segundo": "Segundo contato",
      "buscar": "Buscar",
      "buscarPlaceholder": "nome, telefone ou id do canal",
      "trocar": "Trocar",
      "semAchados": "Nada encontrado",
      "semAchadosAjuda": "Busque pelo identificador do canal — telefone, id do Instagram ou do Telegram. Parte do nome também serve, mas dois clientes podem se chamar igual.",
      "semIdentificador": "sem identificador registrado",
      "marcaAbsorvido": "já unido a outro contato",
      "comeceAqui": "Escolha os dois contatos",
      "comeceAquiAjuda": "Busque cada lado e escolha. Antes de unir, você vê o histórico dos dois.",
      "faltaUmLado": "Falta o outro lado. Busque e escolha o segundo contato para comparar.",
      "mesmoContato": "É o mesmo contato dos dois lados. Escolha dois cadastros diferentes.",
      "jaAbsorvido": "{{nome}} já foi unido ao contato {{outro}}. Só contato vivo pode ser unido — desfaça o vínculo antes, ou una ao contato que sobreviveu.",
      "justificativa": "Por que são a mesma pessoa? (opcional)",
      "justificativaExemplo": "o cliente confirmou o Instagram na conversa de hoje",
      "justificativaAjuda": "A união sugerida guarda a prova sozinha (\"mesmo final de telefone\"). A manual não tem prova nenhuma: sem esta linha, daqui a meses ninguém sabe por que dois históricos viraram um.",
      "unir": "Unir os dois contatos"
    },
    "acervo": {
      "titulo": "Atendimento do acervo",
      "descricao": "O acervo migrado da Zintech se liga ao contato pelo número. Quem chega pelo Instagram ou pelo Telegram não tem número para casar — e o histórico antigo fica invisível. Aqui você liga à mão, e pode desfazer.",
      "contato": "Contato do portal",
      "atendimento": "Atendimento no acervo",
      "buscarPlaceholder": "número ou nome no acervo",
      "semAchados": "Nenhum atendimento encontrado",
      "semAchadosAjuda": "Busque pelo número que atendia o cliente na Zintech, ou pelo nome como ele estava lá.",
      "semNome": "Sem nome no acervo",
      "mensagens": "{{total}} mensagem(ns)",
      "escolhaOContato": "Escolha o contato do portal para poder ligar um atendimento.",
      "jaVinculado": "já ligado ao contato {{contato}}",
      "vincular": "Ligar a este contato",
      "vinculado": "Atendimento ligado ao contato. Você pode desfazer a qualquer momento."
    }
  },
  "ajuda": {
    "titulo": "Ajuda do portal",
    "descricao": "O manual de quem opera. Cada verbete diz onde a tela fica e o que ela decide.",
    "exportar": "Exportar",
    "novo": "Novo verbete",
    "editar": "Editar",
    "remover": "Remover",
    "filtros": "Filtros",
    "buscar": "Buscar",
    "buscarDica": "palavra do título ou do texto",
    "categoria": "Categoria",
    "categoriaDica": "Agrupa para o treinamento — por exemplo: Preço, Atendimento, Configuração.",
    "todasCategorias": "Todas",
    "ordem": "Ordem",
    "ordemDica": "Posição dentro da categoria. Roteiro de treinamento tem sequência.",
    "vazio": "Nenhum verbete ainda",
    "vazioDescricao": "A ajuda existe e está vazia. O primeiro verbete pode ser este: como chegar na simulação de preço.",
    "semResultado": "Nada encontrado",
    "semResultadoDescricao": "Existem verbetes, mas nenhum casa com o filtro atual.",
    "limparFiltro": "Limpar filtro",
    "situacao": {
      "rascunho": "Rascunho",
      "publicado": "Publicado",
      "arquivado": "Arquivado"
    },
    "atualizadoEm": "Atualizado em {{data}} por {{quem}}.",
    "exige": "requer {{permissao}}",
    "novaAba": "abre em nova aba",
    "conteudoDeProduto": "Documentação do portal. Use exemplos fictícios — este texto é exportado.",
    "tituloDoVerbete": "Título",
    "marcas": "Marcas de formatação",
    "marca": {
      "negrito": "Negrito",
      "codigo": "Código",
      "destaque": "Destaque",
      "atencao": "Atenção",
      "perigo": "Perigo",
      "sucesso": "Sucesso"
    },
    "semCor": "As marcas resolvem em cores do tema. Não há escolha de cor: valor escolhido à mão funciona num tema e some no outro.",
    "conteudo": "Conteúdo",
    "telas": "Telas que este verbete explica",
    "telasDica": "Só telas que existem. A ajuda recusa caminho desconhecido — documentação que aponta para tela inexistente é pior que documentação ausente.",
    "acrescentarTela": "Acrescentar tela",
    "escolha": "Escolha…",
    "textoExemplo": "texto",
    "salvo": "Verbete salvo.",
    "tituloDaTela": "Ajuda desta tela",
    "abrirDaTela": "Abrir a ajuda desta tela ({{total}})",
    "semVerbeteDaTela": "Nenhum verbete cobre esta tela ainda.",
    "verTudo": "Ver toda a ajuda",
    "escolhaMarca": " (escolha a marca)"
  },
  "console": {
    "titulo": "Console de teste",
    "descricao": "Converse com o assistente como se fosse um cliente, contra a configuração vigente.",
    "seguro": "Nada daqui sai para fora",
    "seguroDescricao": "A conversa é marcada como teste e as respostas morrem na saída. Nenhuma mensagem chega a um cliente.",
    "assistente": "Assistente",
    "conversa": "Conversa",
    "diagnostico": "Diagnóstico do turno",
    "reiniciar": "Reiniciar sessão",
    "escreva": "Sua mensagem",
    "escrevaDica": "escreva como um cliente escreveria",
    "enviar": "Enviar",
    "vazio": "Sessão nova",
    "vazioDescricao": "Escreva a primeira mensagem. O assistente responde como responderia a um cliente — inclusive o aviso de automação.",
    "semAssistente": "Nenhum assistente nesta marca",
    "semAssistenteDescricao": "O console simula um assistente. Cadastre um para poder testar.",
    "origem": {
      "cliente": "Você (como cliente)",
      "assistente": "Assistente",
      "atendente": "Atendente",
      "sistema": "Sistema"
    },
    "custo": "Custo e tokens",
    "tokens": "{{entrada}} tokens de entrada · {{saida}} de saída",
    "custoDoTurno": "R$ {{valor}} neste turno",
    "reserva": "usou a reserva",
    "marcadoTeste": "marcado como teste",
    "semTurno": "Nenhum turno ainda.",
    "ferramentas": "Ferramentas chamadas",
    "semFerramenta": "Nenhuma ferramenta neste turno.",
    "ferramentasNota": "Argumentos e retorno existem só no console e não são gravados: em conversa real eles podem carregar dado de cliente.",
    "transbordo": "Transbordo",
    "semTransbordo": "Nenhum transbordo.",
    "naoEnviado": "O que NÃO foi enviado",
    "selo": "não enviado",
    "semEnvio": "Nada foi produzido para envio neste turno.",
    "prompt": "Prompt montado",
    "semPrompt": "Não foi possível carregar o prompt.",
    "tetoAtingido": "Teto de custo atingido",
    "argumentos": "o que o modelo mandou",
    "retorno": "o que voltou",
    "pediuTransbordo": "pediu humano"
  },
  "materiais": {
    "titulo": "Materiais que o assistente envia",
    "descricao": "Arquivos que o assistente manda ao cliente quando mostrar é melhor que explicar.",
    "novo": "Novo material",
    "cadastrados": "Cadastrados",
    "chave": "Chave",
    "chaveDica": "É o que o assistente usa para pedir este material. Minúscula e sem espaço — por exemplo, sangria.",
    "tituloDoMaterial": "Título",
    "legenda": "Legenda",
    "legendaDica": "É este texto que chega ao cliente junto do arquivo.",
    "arquivo": "Arquivo",
    "arquivoDica": "Imagem ou PDF. O tipo é conferido pelo conteúdo, não pela extensão.",
    "previaDe": "Pré-visualização de {{titulo}}",
    "inativo": "inativo",
    "ativar": "Ativar",
    "desativar": "Desativar",
    "vazio": "Nenhum material cadastrado",
    "vazioDescricao": "O primeiro costuma ser a arte que explica o que é sangria — foi o pedido que originou esta tela."
  },
  "linhaDoTempo": {
    "titulo": "Linha do tempo ({{total}})",
    "cobertura": "Histórico disponível a partir de {{data}}.",
    "origem": {
      "acervo": "histórico",
      "portal": "portal"
    },
    "canalNaoCasa": "Este canal não casa com o histórico migrado — o identificador do Instagram é por aplicativo, e não há como ligá-lo ao acervo automaticamente.",
    "periodo": "De {{primeira}} a {{ultima}}",
    "canais": "Canais: {{canais}}",
    "abrirNoPortal": "Abrir a conversa na plataforma de atendimento (nova aba)",
    "abrirDoAcervo": "Ver as mensagens deste atendimento",
    "fecharDoAcervo": "Ocultar as mensagens deste atendimento",
    "carregandoAtendimento": "Carregando o atendimento…",
    "falhouAtendimento": "Não foi possível abrir este atendimento."
  },
  "entregas": {
    "titulo": "Entregas e comprovantes",
    "descricao": "O registro da expedição: quem recebeu, quando, e a foto do canhoto. É daqui que sai o comprovante quando o cliente pede.",
    "procurar": "Procurar",
    "limparBusca": "Limpar busca",
    "referencia": "Referência",
    "referenciaDica": "Número do pedido ou da nota. Mínimo de {{minimo}} letras ou números — a busca é exata.",
    "referenciaCadastroDica": "Só o número do pedido ou da nota, sem outro texto — ex.: 64959. É esse número que a equipe escreve ao pedir o comprovante ao Copiloto, e a busca é pelo número exato.",
    "referenciaCurta": "Referência curta demais: informe pelo menos {{minimo}} letras ou números. Nada foi procurado — isto não significa que a entrega não exista.",
    "nova": "Registrar entrega",
    "registrar": "Registrar entrega",
    "registradas": "Entregas registradas",
    "cliente": "Cliente",
    "entregueEm": "Entregue em",
    "recebidoPor": "Recebido por",
    "observacoes": "Observações",
    "fotos": "Comprovante",
    "fotosDica": "Uma ou mais fotos do canhoto, ou o PDF assinado. O tipo é conferido pelo conteúdo, não pela extensão.",
    "previaDe": "Comprovante da entrega {{referencia}}",
    "registradoPor": "Registrado por {{quem}} em {{quando}}",
    "confirmarExclusao": "Confirmar exclusão",
    "editar": "Editar",
    "editarEntrega": "Editar a entrega {{referencia}}",
    "salvarEdicao": "Salvar alterações",
    "referenciaRepetida": "Já existe o registro #{{id}} com a referência {{referencia}}. Duas entregas com a mesma referência deixam a busca ambígua, e o Copiloto não envia nenhuma — exclua ou corrija aquele registro antes.",
    "dataObrigatoria": "Informe a data e a hora da entrega.",
    "referenciaObrigatoria": "Informe a referência: o número do pedido ou da nota.",
    "vazio": "Nenhuma entrega registrada",
    "vazioDescricao": "A expedição registra aqui a entrega com a foto do comprovante — é o que permite ao assistente enviá-lo quando o cliente pedir.",
    "semResultado": "Nenhuma entrega com a referência {{referencia}}",
    "semResultadoDescricao": "A busca é por igualdade: confira o número. Outras entregas continuam registradas.",
    "retencao": "Retenção do comprovante",
    "retencaoExplicacao": "O comprovante costuma trazer assinatura e o documento de quem recebeu. Passado o prazo, o registro e a foto são apagados automaticamente.",
    "retencaoDias": "Dias até o expurgo",
    "retencaoDica": "Padrão de fábrica: {{padrao}} dias. Zero desliga o expurgo — nada é apagado.",
    "retencaoAtual": "Prazo atual: {{dias}} dias.",
    "retencaoDesligada": "O expurgo está desligado: nenhum comprovante será apagado, por mais antigo que seja.",
    "referenciaCurtaCadastro": "A referência precisa ter pelo menos {{minimo}} letras ou números — abaixo disso ela casaria com o pedido errado.",
    "lerFoto": "Ler o comprovante",
    "lendoFoto": "Lendo o comprovante…",
    "lerFotoDica": "Opcional. Lê o primeiro arquivo — foto ou PDF (só a primeira página) — e sugere o preenchimento dos campos que estiverem vazios. Nada é gravado: confira e corrija antes de registrar.",
    "sugerido": "Sugerido pela leitura do comprovante — confira.",
    "sugeridoData": "Data sugerida pela leitura do comprovante — confira. A hora não é lida: ajuste.",
    "leituraFeita_one": "{{count}} campo sugerido — confira antes de registrar.",
    "leituraFeita_other": "{{count}} campos sugeridos — confira antes de registrar.",
    "leituraSemCampos": "Nenhum campo vazio foi preenchido pela leitura. Preencha à mão.",
    "leituraFalhou": "Não foi possível ler o comprovante agora. Preencha os campos à mão — o registro funciona normalmente.",
    "tipoLido": {
      "canhoto_de_nota_fiscal": "O arquivo parece um canhoto de nota fiscal.",
      "comprovante_de_transportadora": "O arquivo parece um comprovante de transportadora.",
      "protocolo_de_entrega": "O arquivo parece um protocolo de entrega. A referência sugerida é o número da OS.",
      "outro": "O arquivo não parece um canhoto de nota fiscal, um protocolo de entrega nem um comprovante de transportadora."
    }
  },
  "arquivos": {
    "titulo": "Banco de arquivos",
    "descricao": "O material que você manda ao cliente durante o atendimento: catálogos, tabelas, guias. Procure, gere o link e cole na conversa.",
    "procurar": "Procurar",
    "limpar": "Limpar busca",
    "termo": "Buscar",
    "termoDica": "Procura no título e na descrição. \"papel\" acha o catálogo mesmo que o arquivo se chame outra coisa.",
    "categoria": "Categoria",
    "categoriaDica": "Agrupa na lista. Use as que já existem ou crie uma nova.",
    "todasAsCategorias": "Todas as categorias",
    "novo": "Publicar material",
    "publicar": "Publicar",
    "disponiveis": "Disponíveis",
    "tituloDoArquivo": "Título",
    "descricaoDoArquivo": "Descrição",
    "descricaoDica": "Para que serve e quando usar. É por aqui que alguém acha o arquivo sem saber o nome dele.",
    "arquivo": "Arquivo",
    "arquivoDica": "Imagem ou PDF. O tipo é conferido pelo conteúdo, não pela extensão.",
    "gerarLink": "Gerar link para o cliente",
    "linkPronto": "Link para colar na conversa",
    "linkExpira": "O link expira e vale só para esta marca. Gere de novo quando precisar.",
    "abrir": "Abrir aqui",
    "retirar": "Retirar de circulação",
    "reativar": "Reativar",
    "inativo": "fora de circulação",
    "vazio": "Nenhum material publicado",
    "vazioDescricao": "Este é o banco de arquivos que existia na ferramenta antiga: catálogo de papéis, tabela de acabamentos, apresentação institucional.",
    "semResultado": "Nenhum material encontrado",
    "semResultadoDescricao": "Tente outra palavra ou limpe o filtro de categoria — a busca olha título e descrição."
  },
  "publicacao": {
    "titulo": "Publicação da configuração",
    "descricao": "O que você edita nas telas de regras, roteamento e assistente é rascunho. O assistente em produção usa a última versão publicada.",
    "pendente": "Há alterações não publicadas. O assistente continua usando a versão publicada até você publicar.",
    "emDia": "Não há diferença pendente: o que está nas telas é o que o assistente usa.",
    "vigente": "Versão em vigor",
    "vigenteDetalhe": "v{{numero}}, publicada por {{quem}} em {{quando}}.",
    "nenhuma": "Nenhuma versão publicada ainda.",
    "observacao": "O que muda nesta publicação",
    "observacaoDica": "Opcional, e é o que alguém vai ler daqui a dois meses tentando entender a mudança.",
    "publicar": "Publicar agora",
    "semDiferenca": "Nada a publicar: a configuração já está igual à versão em vigor.",
    "historico": "Histórico",
    "emVigor": "em vigor",
    "publicadaPor": "Publicada por {{quem}}",
    "restaurar": "Restaurar esta versão",
    "confirmarRestauracao": "Confirmar restauração"
  },
  "frete": {
    "titulo": "Frete",
    "cep": "CEP de destino",
    "cepAjuda": "Para onde a tiragem vai. Só o comercial vê esta cotação.",
    "cotar": "Cotar frete",
    "cotando": "Consultando as transportadoras…",
    "legenda": "Opções de frete para este destino",
    "transportadora": "Transportadora",
    "servico": "Serviço",
    "valor": "Valor",
    "prazo": "Prazo",
    "acao": "Ação",
    "dias": "{{dias}} dia(s)",
    "escolher": "Escolher",
    "estimativaTitulo": "Estes valores são estimativa",
    "estimativa": "A dimensão de embalagem deste produto ainda não está cadastrada, então o volume usado é o padrão da família. Confira antes de fechar com o cliente.",
    "semOpcaoTitulo": "Nenhuma opção para este destino",
    "semOpcao": "As transportadoras não têm serviço para este CEP.",
    "naoResponderamTitulo": "A lista pode estar incompleta",
    "naoResponderam": "Não responderam: {{quais}}. Vale cotar de novo antes de fechar.",
    "escolhidoTitulo": "Frete escolhido",
    "escolhidoResumo": "{{transportadora}} · {{valor}} · {{prazo}} dia(s)",
    "escolhidoCotadoEm": "Cotado em {{quando}}",
    "eraEstimativa": "era estimativa",
    "escolhidoPor": "Escolhido por {{quem}} em {{quando}}",
    "falhouCotar": "Não foi possível cotar o frete agora.",
    "falhouEscolher": "Não foi possível registrar a escolha."
  },
  "logDeEntrega": {
    "titulo": "Log de entrega de documento",
    "descricao": "Quem recebeu o quê, quando, por qual assistente e sob qual identificação. {{total}} entrega(s) no período.",
    "semMarca": "Rota sem marca. Abra o log a partir de uma marca.",
    "tipo": "Documento",
    "documento_": "Documento",
    "todosOsTipos": "Todos",
    "referencia": "Referência",
    "de": "De",
    "ate": "Até",
    "filtrar": "Filtrar",
    "limpar": "Limpar filtros",
    "quando": "Quando",
    "paraQuem": "Para quem",
    "nivel": "Nível atingido",
    "nivelExigido": "Nível exigido",
    "confirmacao": "Confirmação aceita",
    "assistente": "Assistente",
    "vazio": "Nenhum documento foi entregue pelo atendimento ainda.",
    "vazioFiltrado": "Nenhuma entrega corresponde a estes filtros.",
    "documento": {
      "nota_fiscal": "Nota fiscal",
      "segunda_via_de_boleto": "2ª via de boleto",
      "comprovante_de_entrega": "Comprovante de entrega"
    },
    "nivelNome": {
      "Aberto": "Aberto",
      "VinculoDoCanal": "Vínculo do canal",
      "ConfirmacaoDeDado": "Confirmação de dado",
      "Humano": "Atendimento humano"
    },
    "campo": {
      "email": "E-mail",
      "telefone": "Telefone"
    },
    "matriz": {
      "titulo": "Matriz de identificação — o que cada documento exige",
      "descricao": "A identificação vale por conversa e expira em {{minutos}} minutos. {{tentativas}} confirmações erradas encerram a tentativa. Pede-se sempre a parte final do dado ({{digitos}} caracteres), nunca o dado inteiro.",
      "somenteLeitura": "Esta matriz não é editável pelo portal e não tem chave para desligar: é parâmetro de nível CTGF. Documento sem linha aqui exige atendimento humano.",
      "origem": "Origem",
      "deParametro": "Configurada",
      "doPadrao": "Padrão"
    }
  },
  "assistencia": {
    "titulo": "Coleta do orçamento — {{feitos}} de {{total}}",
    "falta": "ainda falta",
    "proxima": "Pergunte agora:",
    "completo": "Tudo que o orçamento precisa já foi informado.",
    "semColeta": "Não há coleta de orçamento em andamento nesta conversa.",
    "rodape": "Este painel só mostra. Nada daqui é enviado ao cliente.",
    "estagio": {
      "orcamento": "Orçamento",
      "documento": "Documento",
      "rastreio": "Rastreio",
      "outro": "Conversa geral"
    }
  },
  "frescor": {
    "em": "Atualizado às {{hora}} ({{idade}})",
    "agora": "agora",
    "minutos_one": "há {{count}} minuto",
    "minutos_other": "há {{count}} minutos",
    "buscando": "Buscando…",
    "atualizar": "Atualizar"
  },
  "embalagens": {
    "titulo": "Embalagens do frete",
    "descricao": "A caixa em que o material viaja e quantos quilos cabem nela. É o que permite contar volumes e cotar frete.",
    "tabela": "Caixa por família",
    "familia": "Família",
    "valor": "Dimensão e capacidade",
    "origem": "Origem",
    "padraoGeral": "Padrão geral",
    "usaOPadrao": "usa o padrão geral",
    "deFabrica": "de fábrica",
    "gravadoPor": "{{quem}} · {{quando}}",
    "valorDe": "Dimensão e capacidade de {{familia}}",
    "formatoAjuda": "Formato: comprimento x largura x altura em centímetros, e depois de uma barra os quilos por volume. Exemplo: 22x22x32/8 — caixa de 22 × 22 × 32 cm com 8 kg cada. Sem a barra, tudo vai em um volume só. Deixe em branco para usar o padrão geral.",
    "semPadrao": "O padrão geral ainda não foi cadastrado. Enquanto ele não existir, o assistente não calcula frete para nenhum produto — encaminha a conversa para uma pessoa.",
    "salvo": "{{total}} embalagem(ns) gravada(s).",
    "nadaMudou": "Nada mudou.",
    "multiplicador": "Multiplicador do frete",
    "multiplicadorValor": "Multiplicador",
    "multiplicadorAjuda": "Acréscimo aplicado ao valor cotado pela transportadora antes de ele chegar ao cliente — 1,2000 acrescenta 20%. Use VÍRGULA decimal, entre {{minimo}} e {{maximo}}. O valor da transportadora continua guardado, para conferência contra a fatura.",
    "multiplicadorDeFabrica": "de fábrica — 1,2000, a decisão de 02/09",
    "multiplicadorIndisponivel": "Não foi possível ler o multiplicador do frete agora. O valor em uso continua o que está gravado — recarregue a página para tentar de novo.",
    "multiplicadorSalvo": "Multiplicador do frete gravado."
  },
  "pendencias": {
    "titulo": "Alterações gravadas e ainda não publicadas",
    "uma": "Há 1 alteração gravada que ainda NÃO está valendo.",
    "varias": "Há {{total}} alterações gravadas que ainda NÃO estão valendo.",
    "explicacao": "O assistente continua usando a versão publicada. Publique para que passem a valer.",
    "semPermissao": "Você não tem permissão para publicar. Peça a quem administra a configuração do portal.",
    "irParaPublicacao": "Ver e publicar",
    "colunaItem": "O que mudou",
    "colunaPublicado": "Valendo agora",
    "colunaVivo": "Gravado (não vale ainda)",
    "ausente": "(não existia)",
    "removido": "(removido)",
    "verMais": "e mais {{quantos}}…"
  },
  "prazos": {
    "titulo": "Prazos de fabricação",
    "descricao": "Quantos dias corridos a produção leva, por família de produto. É o que o assistente soma ao prazo do transporte para dar a data prevista.",
    "tabela": "Prazo por família",
    "familia": "Família",
    "dias": "Dias corridos",
    "valendo": "Valendo hoje",
    "origem": "Origem",
    "geral": "Geral (todas as famílias)",
    "usaOGeral": "usa o geral",
    "semPrazo": "sem prazo — a pergunta vai a uma pessoa",
    "diasCorridos": "{{total}} dia(s) corrido(s)",
    "diasDe": "Dias corridos de {{familia}}",
    "gravadoPor": "{{quem}} · {{quando}}",
    "ajuda": "Dias CORRIDOS, não úteis. Zero significa “não informado”: o assistente não dá previsão e encaminha a pergunta de prazo a uma pessoa — e isso é uma decisão, não uma lacuna. Deixe em branco para a família usar o valor geral.",
    "precisaPublicar": "Há prazo gravado que ainda não foi publicado. O assistente lê a configuração PUBLICADA — até publicar, a mudança não vale na conversa.",
    "nadaMudou": "Nada mudou.",
    "salvo": "{{total}} prazo(s) gravado(s)."
  },
  "modeloComArquivo": {
    "titulo": "Enviar modelo com arquivo",
    "dica": "Para mandar prova ou documento fora da janela de 24 h. Escolha o modelo, preencha o texto e anexe o arquivo do computador.",
    "modelo": "Modelo",
    "escolha": "Escolha um modelo",
    "variavel": "Texto da variável {{nome}}",
    "botao": "Final do link do botão “{{texto}}”",
    "previa": "O cliente vai ler:",
    "arquivo": "Arquivo ({{aceita}}, até {{teto}} MB)",
    "enviar": "Enviar ao cliente",
    "enviarA": "Enviar a {{nome}}",
    "enviando": "Enviando…",
    "enviado": "Modelo {{nome}} aceito pelo Chatwoot — confira o ✓ na conversa no Chatwoot.",
    "destinatario": "Vai para {{nome}} · conversa {{conversa}} · caixa {{caixa}}",
    "useAAba": "Para enviar modelo com arquivo, use a aba “Enviar arquivo”, ao lado desta.",
    "painelEntrar": "Enviar ao cliente exige o login do portal Rio DG (painel.riodg.com.br), com o mesmo e-mail e senha do portal. Você entra uma vez, e a sessão vale pela jornada.",
    "painelSemConversa": "Abra uma conversa no Chatwoot para enviar o modelo.",
    "conectadoComo": "Conectado como {{nome}}",
    "sair": "Sair",
    "outraPessoa": "O login do portal neste navegador é de {{portal}}, e o Chatwoot está com {{chatwoot}}. Entre com o seu login para enviar.",
    "semAgente": "O Chatwoot não informou quem está atendendo. Recarregue a página do Chatwoot e tente de novo.",
    "conversaMudou": "A conversa aberta no Chatwoot mudou. Nada foi enviado: confira o destinatário e envie de novo.",
    "conversaNaoConfirmada": "Não foi possível confirmar qual conversa está aberta no Chatwoot. Nada foi enviado: tente de novo.",
    "semConversa": "Abra esta tela pelo botão do painel, ao lado da conversa.",
    "semNome": "o contato desta conversa",
    "foraDoWhatsapp": "Esta conversa não é de WhatsApp: modelo com arquivo só existe lá.",
    "nenhum": "Esta caixa não tem modelo aprovado com arquivo no cabeçalho.",
    "listaFalhou": "Não foi possível carregar os modelos desta caixa.",
    "naoConfirmado": "O envio não foi confirmado. Confira a conversa no Chatwoot antes de reenviar.",
    "status": {
      "consultando": "{{nome}}, enviado às {{hora}}: consultando o estado do envio…",
      "semEstado": "{{nome}}, enviado às {{hora}}: não foi possível acompanhar o estado do envio. Confira na aba Mensagens.",
      "enviada": "{{nome}}, enviado às {{hora}}: ✓ enviada — ainda não chegou ao aparelho do cliente.",
      "entregue": "{{nome}}, enviado às {{hora}}: ✓✓ entregue ao cliente.",
      "lida": "{{nome}}, enviado às {{hora}}: ✓✓ lida pelo cliente.",
      "falhou": "{{nome}}, enviado às {{hora}}: o envio FALHOU — o cliente não recebeu. Confira o número e o modelo, e envie de novo.",
      "falhouComMotivo": "{{nome}}, enviado às {{hora}}: o envio FALHOU — o cliente não recebeu. Motivo informado pelo WhatsApp: {{motivo}}",
      "parou": "Parei de acompanhar: confira o estado na aba Mensagens."
    }
  },
  "avaliacao": {
    "titulo": "Como foi este atendimento?",
    "dica": "Marque o turno e diga o que deveria ter acontecido. É o que vira correção.",
    "boa": "Certo",
    "ruim": "Errado",
    "escrever": "o que deveria ter acontecido?",
    "editarNota": "editar",
    "pergunta": "O que deveria ter acontecido?",
    "exemplo": "Ex.: devia ter perguntado a gramatura antes de dar o preço.",
    "primeiroONota": "Marque certo ou errado primeiro.",
    "falhou": "Não deu para salvar. Tente de novo.",
    "notaInterna": "nota interna — o cliente não vê",
    "pagina": {
      "titulo": "Avaliações do atendimento",
      "descricao": "O que a equipe apontou em cada turno dos assistentes.",
      "todas": "Todas",
      "somenteRuins": "Só os apontados como errados",
      "somenteBoas": "Só os apontados como certos",
      "vazio": "Nenhuma avaliação registrada ainda.",
      "vazioDica": "O polegar fica no painel de Contexto, ao lado da conversa no Chatwoot.",
      "conversa": "conversa {{numero}}",
      "conversaInteira": "a conversa inteira",
      "abrirNoChatwoot": "abrir no Chatwoot",
      "total": "{{total}} avaliação(ões)",
      "falhou": "Não foi possível carregar as avaliações.",
      "vazioFiltrado": "Nenhum apontamento com esses filtros.",
      "limparFiltros": "Limpar filtros",
      "filtros": "Filtros",
      "estadoTecnico": "Correção",
      "estadoDoCliente": "Validação",
      "assistente": "Assistente",
      "autor": "Quem apontou",
      "desde": "Desde",
      "ate": "Até",
      "numeroDaConversa": "Conversa",
      "ficha": "Ficha",
      "qualquer": "Qualquer",
      "placar": "Placar dos apontamentos",
      "placarTecnico": "Correção dos 👎",
      "placarCliente": "Validação dos solucionados",
      "selecionar": "Selecionar o apontamento {{id}}",
      "selecionados": "{{total}} selecionado(s)",
      "marcarComo": "Marcar como…",
      "limparSelecao": "Limpar seleção",
      "triar": "Atualizar correção",
      "fichaCurta": "Ficha {{ficha}}",
      "noAr": "no ar em {{sha}}",
      "comoValidar": "Como validar",
      "porQuemQuando": "{{quem}} · {{quando}}",
      "validacaoDe": "Validação de {{quem}} · {{quando}}",
      "validadoOk": "Validado OK",
      "naoValidado": "Não validado",
      "oQueContinuaErrado": "O que continua errado?",
      "confirmarNaoValidado": "Registrar não validado",
      "cancelar": "Cancelar",
      "aguardaOutraPessoa": "Solucionado por você — aguarda a validação de outra pessoa.",
      "falhouAoGravar": "Não deu para gravar. Tente de novo.",
      "painel": {
        "tituloUm": "Correção do apontamento",
        "tituloLote": "Correção de {{total}} apontamento(s)",
        "estado": "Estado",
        "oQueFoiFeito": "O que foi feito",
        "motivo": "Motivo",
        "relato": "Relato",
        "comoValidarAjuda": "Escrito para quem não lê código: o que pedir ao assistente e o que ele deve responder.",
        "fichaAjuda": "O número da ficha que trata o defeito, ex.: 233.",
        "gravar": "Gravar",
        "obrigatorio": "Obrigatório para este estado.",
        "ajudaSolucionado": "Solucionado quer dizer NO AR: o código em produção fica gravado junto, e a validação volta a ficar pendente."
      }
    },
    "tecnico": {
      "NaoLido": "Não lido",
      "Lido": "Lido",
      "Solucionado": "Solucionado",
      "NaoSeraTratado": "Não será tratado agora"
    },
    "cliente": {
      "Pendente": "Validação pendente",
      "ValidadoOk": "Validado OK",
      "NaoValidado": "Não validado"
    }
  },
  "modelosWhatsapp": {
    "titulo": "Modelos de WhatsApp",
    "descricao": "Fora das 24 horas desde a última mensagem do cliente, o WhatsApp só aceita modelo aprovado pela Meta. Aqui você cria, acompanha e apaga os modelos de cada número.",
    "caixa": "Número",
    "somenteLeitura": "Seu perfil vê os modelos, mas não cria nem apaga.",
    "sincronizar": "Sincronizar com o Chatwoot",
    "sincronizado": "Pedido enviado: o Chatwoot vai buscar os modelos na Meta.",
    "novo": "Novo modelo",
    "enviar": "Enviar à Meta",
    "criado": "Modelo {{nome}} enviado à Meta — fica \"em análise\" até ela aprovar.",
    "apagar": "Apagar",
    "confirmarApagar": "Apagar o modelo {{nome}} na Meta? Mensagens que o usam deixam de poder ser enviadas.",
    "apagado": "Modelo {{nome}} apagado.",
    "vazio": "Nenhum modelo nesta conta.",
    "semCaixa": "Nenhum número de WhatsApp no Chatwoot.",
    "erroCaixas": "Não foi possível ler os números do Chatwoot.",
    "erroModelos": "Não foi possível ler os modelos na Meta.",
    "motivoDaRecusa": "Motivo da Meta: {{motivo}}",
    "previa": "Como o cliente vai ver (com os exemplos no lugar das variáveis):",
    "situacao": {
      "APPROVED": "aprovado",
      "PENDING": "em análise",
      "REJECTED": "rejeitado",
      "PAUSED": "pausado",
      "DISABLED": "desativado",
      "IN_APPEAL": "em recurso"
    },
    "categoria": {
      "UTILITY": "Utilidade — pedido, nota, boleto, entrega",
      "MARKETING": "Marketing — oferta, promoção",
      "AUTHENTICATION": "Autenticação"
    },
    "campo": {
      "nome": "Nome",
      "categoria": "Categoria",
      "idioma": "Idioma",
      "cabecalho": "Cabeçalho (opcional)",
      "corpo": "Mensagem",
      "exemplo": "Exemplo da variável n.º {{n}}",
      "rodape": "Rodapé (opcional)",
      "botao": "Botão de resposta {{n}} (opcional)"
    },
    "ajuda": {
      "nome": "Só letras minúsculas, números e sublinhado. Ex.: aviso_de_nota_fiscal.",
      "categoria": "A Meta cobra e aprova diferente cada categoria.",
      "corpo": "Use {{1}}, {{2}}… para o que muda em cada envio — cada uma pede um exemplo. A mensagem não pode começar nem terminar com uma variável."
    }
  }
}
